export default __webpack_public_path__ + "static/media/justgivemespace@2x.db7da82e.png";